import { getUserAccount } from '../user/selectors';
import { searchType } from '../util/lodash';

/**
 * Returns the fundamental data for the current userAccount or an empty object if none exists
 * @param state
 * @returns {{ styleColorCodes, rules }}
 */
export const getFundamentals = state => {
  const userAccount = getUserAccount(state) || {};
  return state.fundamentals[userAccount.number] || {};
};

/**
 * Returns an array of rule data
 * @param fundamentals The fundamental data for the current userAccount
 * @param styleColor
 * @returns {[{ graphicType, graphicOption, minimumQuantity, organizationalGraphicUrl, swooshGraphicUrl }]}
 */
export const mapFundamentalDataForStyleColor = (fundamentals, styleColor) => {
  const styleColorData = fundamentals.styleColorCodes[styleColor];

  if (!styleColorData || !Array.isArray(styleColorData.ruleIds)) return [];
  return styleColorData.ruleIds.map(ruleId => fundamentals.rules[ruleId]);
};

/**
 * Returns the rule ID who's graphicType and graphicOption matches for the given productCode (aka styleColor)
 * @param fundamentals
 * @param graphicType
 * @param productCode
 * @param graphicOption
 * @returns {string}
 */
export const getRuleIdWith = (fundamentals, graphicType, graphicOption, productCode) => {
  const ruleIndex = searchType(
    Object.values(fundamentals.rules),
    {
      graphicType,
      graphicOption,
      productCode
    },
    'findIndex'
  );

  return ruleIndex >= 0
    ? Object.keys(fundamentals.rules)[ruleIndex]
    : console.warn(
        `No ruleID with graphicType: ${graphicType}, 
         graphicOption: ${graphicOption} and productCode: ${productCode} found!`
      );
};

/**
 * Returns a rule with the provided ID
 * @param fundamentals
 * @param ruleId
 * @returns {*}
 */
export const getRule = (fundamentals, ruleId) => fundamentals.rules[ruleId];

/**
 * Given a mapFundamentalDataForStyleColor array, return the rule with a matching graphicType and graphicOption
 * @param fundamentals
 * @param graphicType
 * @param graphicOption
 * @returns {Object}
 */
export const getRuleWith = (fundamentals, graphicType, graphicOption) =>
  searchType(fundamentals, { graphicType, graphicOption }, 'find');

/**
 * Return true if the provided productCode is a fundamental product
 * @param fundamentals
 * @param productCode
 * @returns {boolean}
 */
export const isFundamentalProduct = (fundamentals, productCode) =>
  fundamentals && fundamentals.styleColorCodes && Object.keys(fundamentals.styleColorCodes).includes(productCode);
